// extracted by mini-css-extract-plugin
module.exports = {"container":"QR-z","noResults":"RR-z","contact":"SR-z"};